import { Vector2, Vector3 } from 'three'
import InteractiveTile from './components/InteractiveTile/InteractiveTile'
import { coordsToKey } from './scripts/helpers/coordsKeyConverter'
import { useSceneStore } from '../../a.scenes/GameScene/store'
import React, { useEffect, useRef, useState } from 'react'
import { addEventListener, EVENTS_INPUT } from '../../b.providers/EventsProvider/EventsProvider'
import { Bounds } from '@react-three/drei'
import { useFrame, useThree } from '@react-three/fiber'

enum ACTION_TYPES {
  IDLE = 'IDLE',
  DRAGGING = 'DRAGGING',
  CANCEL = 'CANCEL',
  CONFIRM = 'CONFIRM',
}

const Grid = () => {
  // LOCAL STATE
  const [path, setPath] = useState<Vector2[]>([])
  const lastPointerOver = useRef<Vector2 | null>(null)
  const lastPointerOut = useRef<Vector2 | null>(null)
  const [[attackFromCoords, attackToCoords], setAttackCoords] = useState<(Vector2 | null)[]>([])
  const [attackRange, setAttackRange] = useState<Vector2[]>([])
  const actionState = useRef<ACTION_TYPES>(ACTION_TYPES.IDLE)
  const capturedEvent = useRef<null | any>(null)

  // STATE
  const grid = useSceneStore(s => s.terrain.data.grid)
  const boardIsLocked = useSceneStore(s => s.terrain.data.isLocked)
  const selectedCoords = useSceneStore(s => s.terrain.data.selectedTile)

  // VARS
  const gridElements = grid.flatMap(row => row)

  // HANDLERS
  
  // EFFECTS
  useEffect(() => {
    window.document.body.style.userSelect = 'none'
    window.addEventListener(
      'contextmenu',
      function (e) {
        // do something here...
        e.preventDefault()
      },
      false,
    )
  }, [])

  useEffect(() => {
    // listener to capture pointer up from elements and discard hovered tile
    const unsub = addEventListener(EVENTS_INPUT.POINTER_UP, ({ payload }) => {
      capturedEvent.current = payload
    })
    return () => unsub()
  }, [])

  // useEffect(() => {
  //   if (selection) {
  //     // console.log('dragging')
  //     actionState.current = ACTION_TYPES.DRAGGING
  //   } else {
  //     // console.log('not dragging')
  //     actionState.current = ACTION_TYPES.IDLE
  //   }
  // }, [selection])
  const { camera } = useThree()
  
  useFrame(({ camera }) => {
    if (camera.userData.originalPosition && !camera.position.equals(camera.userData.originalPosition)) {
      camera.position.set(
        camera.userData.originalPosition.x,
        camera.userData.originalPosition.y,
        camera.userData.originalPosition.z,
      )
    }
  })

  // RENDER
  return (
    <Bounds
      onFit={data => {
        setTimeout(() => {
          // if (!camera.userData.originalPosition) {
            camera.userData.originalPosition = camera.position.clone().add(new Vector3(-2.294, 0, -0.5))
            camera.userData.originalNear = camera.near
            camera.userData.originalFar = camera.far
            camera.userData.cameraUpdates = 0
            camera.userData.cameraOffset = camera.position.clone().distanceTo(camera.userData.originalPosition)

            camera.position.set(
              camera.userData.originalPosition.x,
              camera.userData.originalPosition.y,
              camera.userData.originalPosition.z,
            )
          // }
        }, 100)
      }}
      fit
      clip
      margin={0.8}
    >
      <group position={[0, 0.1, 0]}>
        {gridElements.map(
          i =>
            i.isValid && (
              <InteractiveTile
                // visible={false}
                key={`${coordsToKey(i.coords)}_tile`}
                coords={i.coords}
                position={i.position}
                onHover={(isHovered: boolean) => {
                  if (isHovered) {
                    lastPointerOver.current = i.coords
                  } else {
                    lastPointerOut.current = i.coords
                  }
                }}
                allowInteraction={!boardIsLocked}
                // onClick={() => handleClick(i.coords)}
                // onPointerDown={() => pointerDownHandler(i.coords)}
                isSelected={selectedCoords?.equals(i.coords)}
                isActionable={
                  attackRange.find(c => c.equals(i.coords)) !== undefined
                  // Boolean(selectedElementState) &&
                  // positionToCoords(selectedElementState!.position, gridOrigin).equals(i.coords)
                }
                isAttachOrigin={attackFromCoords?.equals(i.coords)}
                isAttachDestination={attackToCoords?.equals(i.coords)}
                // isPath={i.coords.equals(hoveredCoods)}
                isPath={path.find(c => i.coords.equals(new Vector2(c.x, c.y))) !== undefined}
              />
            ),
        )}
      </group>
    </Bounds>
  )
}

export default Grid
